//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MetadadosExtensao from './MetadadosExtensao';

export default {
  components: {
    MetadadosExtensao,
  },
  props: {
    metadadosEntidade: {
      type: Object,
      default: {},
    },
    objeto: Object,
    callbackFiltro: Function,
  },
  data() {
    return {
      dialogRecursao: false,
      entidadeRecursivaEmFiltro: null,
      dependenciasRecursivas: [],

      filtroRecursao: {},
    };
  },
  computed: {
    raizRecursao() {
      const raiz = this.dependenciasRecursivas
        .filter(dependencia => dependencia.indiceRecursao === 0)[0],
        { label } = raiz;
      return label;
    },
  },
  methods: {
    filtraAmostragemRecursiva(metadadosExtensao) {
      this.entidadeRecursivaEmFiltro = metadadosExtensao;
      this.determinaDependenciasRecursivas();

      this.dialogRecursao = true;
      setTimeout(() => this.carregaValoresPrevios());
    },
    carregaValoresPrevios() {
      const filtro = this.filtroRecursao,
        objeto = this.objeto;

      this.dependenciasRecursivas
        .filter((dependencia) => {
          const { label } = dependencia,
            valor = objeto[label];
          return valor != null && Object.keys(valor).length !== 0;
        })
        .forEach((dependencia) => {
          const { label } = dependencia;
          if (dependencia.manyToMany) {
            filtro[label] = [...objeto[label]];
          } else {
            filtro[label] = { ...objeto[label] };
          }
        });

      this.filtroRecursao = { ...filtro };
    },
    campoFiltrado() {
      const entidade = this.filtroRecursao[this.raizRecursao];
      return entidade != null && Object.keys(entidade) !== 0;
    },
    valorSelecionado(alteracao) {
      const { dependentes, label } = alteracao.metadados,
        { selecao } = alteracao,
        dependente = dependentes[0];

      if (selecao) {
        if (alteracao.metadados.manyToMany) {
          this.filtroRecursao[label] = [...selecao];
        } else {
          this.filtroRecursao[label] = { ...selecao };
        }
      } else {
        delete this.filtroRecursao[label];
      }

      this.limpaDependentes(dependente);
    },
    limpaDependentes(dependencia) {
      const listaDependentes = this.getDependentes(dependencia);
      const objeto = this.filtroRecursao;
      listaDependentes.forEach((entidade) => {
        delete objeto[entidade.label];
      });
      this.filtroRecursao = { ...objeto };
    },
    getValoresDependencias(dependente) {
      if (!dependente) return [];

      const listaDependencias = this.getDependencias(dependente),
        valores = [],
        objeto = this.filtroRecursao;

      listaDependencias
        .filter((entidade) => {
          const { label } = entidade;
          return objeto[label] && Object.keys(objeto[label]).length !== 0;
        })
        .forEach((entidade) => {
          const { label, idNivelExtensao, indiceRecursao } = entidade;
          const { id } = objeto[label];
          valores.push({ id, idNivelExtensao, indiceRecursao });
        });

      if (valores.length === 0) {
        return [];
      }

      let menorIndiceRecursao = Number.MAX_SAFE_INTEGER;
      let menorDependencia = null;
      valores.forEach((valor) => {
        if (valor.indiceRecursao < menorIndiceRecursao) {
          menorIndiceRecursao = valor.indiceRecursao;
          menorDependencia = valor;
        }
      });
      return [menorDependencia];
    },
    getDependentes(dependencia) {
      const listaDependentes = [];
      const dependencias = [...this.dependenciasRecursivas];
      let referencia = dependencia;

      while (referencia !== null) {
        const dependente = dependencias
          .filter((dependenciaRec) => { // eslint-disable-line no-loop-func
            const { label } = dependenciaRec;
            return referencia === label;
          })[0];

        if (dependente) {
          listaDependentes.push(dependente);
          referencia = dependente.dependentes[0];
        } else {
          referencia = null;
        }
      }

      return listaDependentes;
    },
    getDependencias(dependente) {
      const listaDependencias = [];
      const dependencias = [...this.dependenciasRecursivas];
      let referencia = dependente;

      while (referencia !== null) {
        const dependencia = dependencias
          .filter((dependenciaRec) => { // eslint-disable-line no-loop-func
            const { label } = dependenciaRec;
            return referencia === label;
          })[0];

        if (dependencia) {
          listaDependencias.push(dependencia);
          referencia = dependencia.dependencias[0];
        } else {
          referencia = null;
        }
      }

      return listaDependencias;
    },
    determinaDependenciasRecursivas() {
      const metadados = this.metadadosEntidade,
        entidade = metadados.entidade;

      const dependenciasIndiretas = Object.values(metadados.mapaEntidades)
        .filter(dependencia => dependencia.dependentes.indexOf(entidade) < 0);

      const eleitasFiltro = {};

      let novaEleita = null;
      let dependente = this.entidadeRecursivaEmFiltro.label;
      do {
        novaEleita = dependenciasIndiretas
          .filter(dependencia => // eslint-disable-line no-loop-func
            dependencia.dependentes.indexOf(dependente) >= 0,
          ).filter(dependencia =>  // eslint-disable-line no-loop-func
            !eleitasFiltro[dependencia.label],
          )[0];
        eleitasFiltro[novaEleita.label] = novaEleita;

        if (novaEleita.dependencias.length > 0) {
          dependente = novaEleita.label;
        } else {
          dependente = null;
        }
      } while (dependente);

      this.dependenciasRecursivas = [
        this.entidadeRecursivaEmFiltro,
        ...Object.values(eleitasFiltro),
      ].reverse();
    },
    aplicarFiltroAmostragem() {
      const copia = { ...this.filtroRecursao };
      this.callbackFiltro(copia);

      this.dialogRecursao = false;
      this.entidadeRecursivaEmFiltro = null;
      this.filtroRecursao = {};
    },
    cancelarFiltroAmostragem() {
      this.dialogRecursao = false;
      this.entidadeRecursivaEmFiltro = null;
      this.filtroRecursao = {};
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/MetadadosFiltrosRecursivos.vue?vue&type=script&lang=js&